export default {"src":"/_next/static/media/gyazo.af1e3a4d.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};